import {
  MapPin,
  Cloud,
  BadgeDollarSign,
  Clock,
  HeartHandshake,
  BookOpen,
  Users,
  LineChart,
  ShieldCheck,
  LifeBuoy,
  PiggyBank,
  SlidersHorizontal,
  Target,
  Sparkles,
  Check,
  Phone,
  Mail,
  ArrowRight,
  ArrowLeft,
  Menu,
  X,
  CalendarClock,
  Quote,
  Facebook,
  Instagram,
  Linkedin,
} from "lucide-react";

const registry = {
  MapPin,
  Cloud,
  BadgeDollarSign,
  Clock,
  HeartHandshake,
  BookOpen,
  Users,
  LineChart,
  ShieldCheck,
  LifeBuoy,
  PiggyBank,
  SlidersHorizontal,
  Target,
  Sparkles,
  Check,
  Phone,
  Mail,
  ArrowRight,
  ArrowLeft,
  Menu,
  X,
  CalendarClock,
  Quote,
  Facebook,
  Instagram,
  Linkedin,
};

export const Icon = ({ name, className = "", strokeWidth = 1.75 }) => {
  const Cmp = registry[name];
  if (!Cmp) return null;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};

export default Icon;
